// DEPENDENCIES
import React  from 'react';

// INNER IMPORTS
import './MusicStyles.css';

// 'Music Styles' : 'Sub Categories'
const MusicStyles = props => (
    <div className="musicStyles rtl">
        <div className={`title ${props.type} ${(props.userShouldEnter && props.userShouldEnter.indexOf("subCategories")>-1?"required":null)}`}>
            {props.type === 'liveMusic' ? 'סגנון מוזיקה' : 'תת קטגוריות'}
        </div>
        <div className="subCategories">
            {props.datatypes ? (props.datatypes.subCategories[props.category] || []).map((subCategory, index) => {
                return (
                    <div className={"subCategory "+(props.subCategories.indexOf(subCategory)>-1?"selected":null)}
                         key={index}
                         onClick={()=>props.selectSubCategory(subCategory)}>
                        {subCategory}
                    </div>
                )
            }):""}
        </div>
    </div>
);
export default MusicStyles;



// WEBPACK FOOTER //
// ./src/Components/Users/Submit/MusicStyles.js